import React from 'react';
import BusinessLanding from './BusinessLanding';
import ChatBox from './ChatBox';

function App() {
  return (
    <div>
      <BusinessLanding />
      <ChatBox />
    </div>
  );
}

export default App;